import { Link } from 'react-router-dom';

const entries = [
  {
    type: 'movie',
    title: '电影专区',
    subtitle: '精选高分佳片',
    desc: '科幻、悬疑、动作、爱情…… 一览院线新片与口碑佳作。',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20with%20glowing%20screen%20and%20empty%20red%20seats%20deep%20blue%20darkness%20warm%20orange%20accent%20light%2C%20wide%20editorial%20photography&width=800&height=500&seq=cat-movie&orientation=landscape',
    count: '12 部',
  },
  {
    type: 'tv',
    title: '电视剧专区',
    subtitle: '热播剧集追踪',
    desc: '武侠、都市、悬疑、历史…… 追更不停，好剧一网打尽。',
    icon: 'ri-tv-2-line',
    image: 'https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20warm%20lamp%20light%20and%20a%20glowing%20television%20screen%20deep%20blue%20evening%20window%2C%20wide%20editorial%20photography&width=800&height=500&seq=cat-tv&orientation=landscape',
    count: '12 部',
  },
];

export default function CategoryQuickNav() {
  return (
    <section className="max-w-8xl mx-auto px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {entries.map((item) => (
          <Link
            key={item.type}
            to={`/category?type=${item.type}`}
            className="group relative h-[200px] md:h-[240px] rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={item.image}
              alt={item.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-transparent"></div>
            <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-8 max-w-md">
              <span className="w-12 h-12 rounded-lg bg-accent-500 flex items-center justify-center text-primary-950 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">{item.title}</h3>
                <span className="px-2 py-0.5 rounded-full bg-background-50/15 text-background-100 text-[11px] font-label">{item.count}</span>
              </div>
              <p className="mt-1 text-xs font-bold tracking-widest text-accent-400 font-label">{item.subtitle}</p>
              <p className="mt-3 text-sm text-background-200 leading-relaxed line-clamp-2">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-background-50 group-hover:text-accent-400 transition-colors">
                立即进入
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}